<template>
  <div
    id="modal_showAppLog"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
    >
      <div
        class="modal-content"
        style="border-style: dashed; border-width: 1px"
      >
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('modal_showAppLog')"
          >
            &times;
          </button>
        </div>
        <table id="head-table">
          <tr>
            <td style="padding-left: 20px">
              <img
                style="width: 110px; height: 100px"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%; margin-left: 0px"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="table-header">
                <h4 style="margin-bottom: 0px">
                  <strong>
                    <span v-if="detialData.description === 'Add to Credit'">Refund Invoice</span>
                    <span v-else>Shopping Online Invoice</span>
                  </strong>
                </h4>
                <!-- <h5 style="display: block; margin: 0px;">#{{ detialData.theOrderID }}</h5> -->
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td id="info-section1">
                <!-- <p style="font-size: 15px; font-weight: bold">
                  Branch:
                  <span style="font-weight: normal"> {{ detialData.branch_name }}</span>
                </p> -->
                <p style="font-size: 15px; font-weight: bold">
                  Invoice Number:
                  <span style="font-weight: normal"> {{ detialData.invoice_number }}</span>
                </p>
                <p
                  v-if="detialData.credit_log_transaction_date != null"
                  style="font-size: 15px; font-weight: bold"
                >
                  Invoice Date:
                  <span style="font-weight: normal">
                    {{ detialData.credit_log_transaction_date }}</span>
                </p>
                <p
                  v-else
                  style="font-size: 15px; font-weight: bold"
                >
                  Invoice Date:
                  <span style="font-weight: normal"> {{ detialData.created_at }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold">
                  Description:
                  <span style="font-weight: normal"> {{ detialData.description }}</span>
                </p>
                <p
                  v-if="detialData.description != 'Add to Credit'"
                  style="font-size: 15px; font-weight: bold"
                >
                  From/To Date:
                  <span style="font-weight: normal"> {{ detialData.from_date }} - {{ detialData.to_date }}</span>
                </p>
              </td>
              <td id="info-section2">
                <p style="font-size: 15px; font-weight: bold">
                  Order: <span style="font-weight: normal">{{ detialData.theOrderID }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold">
                  Customer Name: <span style="font-weight: normal">{{ detialData.full_name }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold">
                  Customer Address:
                  <span style="font-weight: normal">{{ detialData.address }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold">
                  Customer Tel:
                  <span style="font-weight: normal">{{ detialData.phone_number }}</span>
                </p>
              </td>
            </tr>
          </table>

          <!-- IF THE ORDER IS REFUND -->
          <table
            style="width: 100%"
            v-if="detialData.description === 'Add to Credit'"
            id="print-table3"
          >
            <tr>
              <td
                id="price-section"
                style="padding-top: 30px; padding-bottom: 30px"
              >
                <p style="font-size: 15px; font-weight: bold">Refund reason</p>
                <p style="font-size: 15px; font-weight: bold">Money amount</p>
              </td>
              <td
                id="price-section1"
                style="padding-top: 30px; padding-bottom: 30px"
              >
                <p style="font-size: 15px; font-weight: normal">: {{ detialData.refund_reason }}</p>
                <p style="font-size: 15px; font-weight: normal">: ${{ detialData.money_amount }}</p>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%; border: 1px solid;"
            v-else
            id="print-table3"
          >
            <tr>
              <td class="order-invoice-left-td">Product Name: </td>
              <td class="order-invoice-right-td">{{ detialData.product_name }}</td>
            </tr>

            <tr>
              <td class="order-invoice-left-td">Quantity: </td>
              <td class="order-invoice-right-td">{{ detialData.quantity }}</td>
            </tr>

            <tr>
              <td class="order-invoice-left-td">Quantity Charge: </td>
              <td class="order-invoice-right-td">${{ detialData.quantity_charge }}</td>
            </tr>

            <tr>
              <td class="order-invoice-left-td">Item Price: </td>
              <td class="order-invoice-right-td">${{ detialData.item_price }}</td>
            </tr>

            <tr v-if="detialData.tax">
              <td class="order-invoice-left-td">Tax: </td>
              <td class="order-invoice-right-td">${{ detialData.tax }}</td>
            </tr>

            <tr v-if="detialData.internal_shipping_handling">
              <td class="order-invoice-left-td">Int. Shipment: </td>
              <td class="order-invoice-right-td">${{ detialData.internal_shipping_handling }}</td>
            </tr>

            <tr v-if="detialData.insurance">
              <td class="order-invoice-left-td">Insurance: </td>
              <td class="order-invoice-right-td">${{ detialData.insurance }}</td>
            </tr>

            <tr v-if="detialData.delivery_price">
              <td class="order-invoice-left-td">Delivery Price: </td>
              <td class="order-invoice-right-td">${{ detialData.delivery_price }}</td>
            </tr>

            <tr v-if="detialData.kreenex_fee">
              <td class="order-invoice-left-td">ShipZone Fee: </td>
              <td class="order-invoice-right-td">${{ detialData.kreenex_fee }}</td>
            </tr>
          </table>

          <!-- <table style="width: 100%" v-else id="print-table3">
            <tr>
              <td id="price-section">
                <p style="font-size: 15px; font-weight: bold">Product Name</p>
                <p style="font-size: 15px; font-weight: bold">Quantity</p>
                <p style="font-size: 15px; font-weight: bold">Quantity Charge</p>
                <p style="font-size: 15px; font-weight: bold">Item Price</p>
                <p v-if="detialData.tax != null" style="font-size: 15px; font-weight: bold">Tax</p>
                <p
                  v-if="detialData.internal_shipping_handling != null"
                  style="font-size: 15px; font-weight: bold"
                >
                  Int. Shipment
                </p>
                <p v-if="detialData.insurance != null" style="font-size: 15px; font-weight: bold">
                  Insurance
                </p>
                <p
                  v-if="detialData.delivery_price != null"
                  style="font-size: 15px; font-weight: bold"
                >
                  Delivery Price
                </p>
                <p v-if="detialData.kreenex_fee != null" style="font-size: 15px; font-weight: bold">
                  ShipZone Fee
                </p>
              </td>
              <td id="price-section1">
                <p style="font-size: 15px; font-weight: normal">: {{ detialData.product_name }}</p>
                <p style="font-size: 15px; font-weight: normal">: {{ detialData.quantity }}</p>
                <p style="font-size: 15px; font-weight: normal">
                  : ${{ detialData.quantity_charge }}
                </p>
                <p style="font-size: 15px; font-weight: normal">: ${{ detialData.item_price }}</p>
                <p  style="font-size: 15px; font-weight: normal">: ${{ detialData.tax }}</p>
                <p style="font-size: 15px; font-weight: normal">
                  : ${{ detialData.internal_shipping_handling }}
                </p>
                <p style="font-size: 15px; font-weight: normal">: ${{ detialData.insurance }}</p>
                <p style="font-size: 15px; font-weight: normal">
                  : ${{ detialData.delivery_price }}
                </p>
                <p style="font-size: 15px; font-weight: normal">: ${{ detialData.kreenex_fee }}</p>
              </td>
            </tr>
          </table> -->

          <table style="width: 100%">
            <tr v-if="detialData.description === 'Add to Credit'">
              <td style="border: 1px solid #000; text-align: right; padding-right: 10px">
                <p style="font-size: 15px; font-weight: bold">
                  Total:
                  <span style="font-weight: normal"><b>${{ detialData.money_amount }}</b></span>
                </p>
              </td>
            </tr>

            <tr v-else>
              <td style="border: 1px solid #000; text-align: right; padding-right: 10px">
                <p style="font-size: 15px; font-weight: bold; margin: 2px 0px">
                  Total:
                  <span style="font-weight: normal"><b>${{ detialData.amount }}</b></span>
                </p>
                <p
                  v-if="detialData.paid_amount"
                  style="font-size: 15px; font-weight: bold; margin: 2px 0px"
                >
                  Paid:
                  <span style="font-weight: normal"><b>${{ detialData.paid_amount }}</b></span>
                </p>
                <p
                  v-if="detialData.paid_amount"
                  style="font-size: 15px; font-weight: bold; margin: 2px 0px"
                >
                  Remain:
                  <span style="font-weight: normal"><b>${{ (detialData.amount - Number(detialData.paid_amount)).toFixed(2) }}</b></span>
                </p>
              </td>
            </tr>
          </table>

          <div style="float: right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height: auto"
              outline
              color="primary"
            >Print</v-btn>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detialData', 'closeModal', 'companyData'],

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
  },

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] })

      $('#close-button').show()
      $('#print-button').show()
    },
  },
}
</script>

<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #table-header {
    width: 500px;
    padding-left: 60px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    margin-left: 0%;
    margin-right: 20px;
    padding: 0px;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logs/viewLogDetails.vue